<template>
  <customModal :containerxl="true" @closeModal="closeModal">
    <template #title>
    <h4 class="my-0">
      {{ $t("navigations.kpis risk score") }}
    </h4>
    
    </template>
    <template #body>

              <!-- <button class="btn btn-sm btn-outline-primary py-0 float-right mb-1" @click.prevent="createSchedule()">Create schedule</button> -->

        <div class="table-responsive custom-dark-table-wrapper">
        <table class="table table-striped dark-table-head mb-0">
            <thead>
                <tr>
                <th> {{ $t("navigations.kpi") }} </th>
                <th> {{ $t("navigations.score") }} </th>
               
                </tr>
            </thead>
           
            <tbody>
                <tr v-for="item in kpiwithscores" :key="item.id">
                    <td> {{  item.kpiName  }}</td>
                    <td> {{  item.score }}</td>
                   
                </tr>
            </tbody>
        </table>
        </div>
    </template>
  </customModal>
</template>

<script src="./monitor-kpi-modal.js"></script>

<style scoped>

.custom-dark-table-wrapper {
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  vertical-align: middle;
  border-color: #dee2e6;
}
.dark-table-head > thead {
  --bs-table-accent-bg: hsl(205, 72%, 37%) !important;
  color: #ffffff !important;
}
.dark-table-head thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}
.tool-tip {
  position: absolute;
  bottom: 100%;
  background-color: #333;
  color: white;
  padding: 5px 10px;
  border-radius: 3px;
  font-size: 0.75rem;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  pointer-events: none;
  z-index: 1001;
  margin-bottom: 5px;
}

.position-relative:hover .tool-tip {
  opacity: 1;
  visibility: visible;
}

</style>